/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * 是否身份证
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isCardNo(arg) {
  var reg = /W|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(arg)
}

/**
 * 是否手机号码
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isPhoneNumber(arg) {
  return /^1[3456789]\d{9}$/.test(arg)
}

/**
 * 是否是正整数
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isPositiveInteger(arg) {
  return /(^[1-9]\d*$)/.test(arg)
}

/**
 * 是否是银行卡
 * @param {Number} cardNumber
 * @returns {Boolean}
 */
export function isValidBankCard(cardNumber) {
  cardNumber = cardNumber.replace(/\s+/g, '')
  let LUHN_SUM = 0
  const cardNumberArray = cardNumber.split('').reverse()

  for (let i = 0; i < cardNumberArray.length; i++) {
    let digit = parseInt(cardNumberArray[i], 10)
    if ((i + 1) % 2 === 0) {
      digit *= 2
      if (digit > 9) {
        digit -= 9
      }
    }
    LUHN_SUM += digit
  }

  return LUHN_SUM % 10 === 0
}

/**
 * 保留两位小数
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isPrice (arg) {
  return /^\d+(\.\d{1,2})?$/.test(arg)
}
